export default __webpack_public_path__ + "assets/86982b20b6d7ce44d6d90e82ec99a89e.jpg";